import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import ProjectApi from "../../api/projectApi";
import axios from "../../api/axiosinstance";

import {
  showSuccess,
  showError,
} from "../../utils/toastUtils";

function CreateProject() {
  const navigate = useNavigate();

  const { leadId } = useParams();

  /*
   * leadId hai = Sales se project create ho raha hai
   * leadId nahi hai = Developer direct project create kar raha hai
   */
  const isSalesProject = Boolean(leadId);
  const isDirectProject = !leadId;

  /* =========================================
     DEVELOPERS
  ========================================= */

  const [developers, setDevelopers] = useState([]);

  const [loadingDevelopers, setLoadingDevelopers] =
    useState(false);

  /* =========================================
     LOADING
  ========================================= */

  const [loading, setLoading] =
    useState(false);

  /* =========================================
     FORM DATA
  ========================================= */

  const [formData, setFormData] =
    useState({
      projectName: "",
      assignedDeveloper: "",
      priority: "medium",
      deadline: "",
      notes: "",
    });

  /* =========================================
     FETCH DEVELOPERS

     IMPORTANT:
     Developers sirf Sales project ke
     case mein load honge.
  ========================================= */

  useEffect(() => {
    /*
     * Direct project mein developer dropdown
     * ki zaroorat nahi hai.
     *
     * Backend automatically logged-in
     * developer ko assign karega.
     */
    if (!isSalesProject) {
      setDevelopers([]);
      setLoadingDevelopers(false);
      return;
    }

    const fetchDevelopers = async () => {
      try {
        setLoadingDevelopers(true);

        const res = await axios.get(
          "/users/developers"
        );

        console.log(
          "DEVELOPERS RESPONSE:",
          res
        );

        if (res?.code === 200) {
          const developerList =
            Array.isArray(res?.data)
              ? res.data
              : Array.isArray(res?.data?.users)
                ? res.data.users
                : [];

          setDevelopers(developerList);
        } else {
          setDevelopers([]);
        }
      } catch (error) {
        console.error(
          "DEVELOPER FETCH ERROR:",
          error
        );

        setDevelopers([]);

        showError(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to load developers"
        );
      } finally {
        setLoadingDevelopers(false);
      }
    };

    fetchDevelopers();
  }, [isSalesProject]);

  /* =========================================
     HANDLE CHANGE
  ========================================= */

  const handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =========================================
     CREATE PROJECT
  ========================================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* =======================================
       PROJECT NAME VALIDATION
    ======================================= */

    if (!formData.projectName.trim()) {
      showError(
        "Project name is required"
      );

      return;
    }

    /* =======================================
       SALES PROJECT

       Sales project ke liye developer
       manually select karna compulsory hai.
    ======================================= */

    if (
      isSalesProject &&
      !formData.assignedDeveloper
    ) {
      showError(
        "Please select a developer"
      );

      return;
    }

    try {
      setLoading(true);

      /* =====================================
         PAYLOAD
      ===================================== */

      const payload = {
        /*
         * leadId sirf Sales project mein
         * bhejna hai.
         */
        ...(isSalesProject
          ? {
              leadId,
              assignedDeveloper:
                formData.assignedDeveloper,
            }
          : {}),

        projectName:
          formData.projectName.trim(),

        priority:
          formData.priority,

        deadline:
          formData.deadline || null,

        notes:
          formData.notes?.trim() || "",
      };

      console.log(
        "CREATE PROJECT PAYLOAD:",
        payload
      );

      const res =
        await ProjectApi.create(
          payload
        );

      console.log(
        "CREATE PROJECT RESPONSE:",
        res
      );

      /* =====================================
         SUCCESS
      ===================================== */

      if (
        res?.code === 200 ||
        res?.code === 201
      ) {
        showSuccess(
          res?.message ||
            "Project Created Successfully"
        );

        setTimeout(() => {
          navigate("/projects");
        }, 800);

        return;
      }

      /* =====================================
         ERROR RESPONSE
      ===================================== */

      showError(
        res?.message ||
          "Failed to create project"
      );
    } catch (error) {
      console.error(
        "CREATE PROJECT ERROR:",
        error
      );

      showError(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================
     RETURN
  ========================================= */

  return (
    <div className="content">

      <div className="card border-0 shadow-sm">

        {/* =====================================
            HEADER
        ====================================== */}

        <div className="card-header bg-white">

          <div>
            <h4 className="mb-1">
              🚀 Create Project
            </h4>

            <small className="text-muted">
              {isDirectProject
                ? "Create a direct project without Sales / Lead"
                : "Create project from Sales Lead"}
            </small>
          </div>

        </div>

        <div className="card-body">

          <form
            onSubmit={
              handleSubmit
            }
          >

            {/* =====================================
                DIRECT PROJECT INFO
            ====================================== */}

            {isDirectProject && (
              <div className="alert alert-info">

                <strong>
                  Direct Project
                </strong>

                <div className="small mt-1">
                  This project is being
                  created directly and
                  is not linked to any
                  Sales Lead.
                </div>

              </div>
            )}

            {/* =====================================
                SALES PROJECT INFO
            ====================================== */}

            {isSalesProject && (
              <div className="alert alert-success">

                <strong>
                  Sales Project
                </strong>

                <div className="small mt-1">
                  This project is being
                  created from a Sales Lead.
                  Please select the developer
                  who will work on this project.
                </div>

              </div>
            )}

            {/* =====================================
                PROJECT NAME
            ====================================== */}

            <div className="mb-3">

              <label className="form-label">
                Project Name
              </label>

              <input
                type="text"
                className="form-control"
                name="projectName"
                value={
                  formData.projectName
                }
                onChange={
                  handleChange
                }
                placeholder="Enter project name"
                required
              />

            </div>

            {/* =====================================
                DEVELOPER

                IMPORTANT:
                Sirf Sales project mein show hoga.
            ====================================== */}

            {isSalesProject && (
              <div className="mb-3">

                <label className="form-label">
                  Assign Developer
                </label>

                <select
                  className="form-select"
                  name="assignedDeveloper"
                  value={
                    formData.assignedDeveloper
                  }
                  onChange={
                    handleChange
                  }
                  disabled={
                    loadingDevelopers
                  }
                  required
                >

                  <option value="">
                    {loadingDevelopers
                      ? "Loading developers..."
                      : "Select Developer"}
                  </option>

                  {developers.map(
                    (developer) => (
                      <option
                        key={
                          developer?._id
                        }
                        value={
                          developer?._id
                        }
                      >
                        {developer?.name ||
                          developer?.username ||
                          developer?.email ||
                          "Unnamed Developer"}
                      </option>
                    )
                  )}

                </select>

                {!loadingDevelopers &&
                  developers.length === 0 && (
                    <small className="text-danger d-block mt-2">
                      No active developers found.
                    </small>
                  )}

              </div>
            )}

            {/* =====================================
                PRIORITY
            ====================================== */}

            <div className="mb-3">

              <label className="form-label">
                Priority
              </label>

              <select
                className="form-select"
                name="priority"
                value={
                  formData.priority
                }
                onChange={
                  handleChange
                }
              >

                <option value="low">
                  Low
                </option>

                <option value="medium">
                  Medium
                </option>

                <option value="high">
                  High
                </option>

              </select>

            </div>

            {/* =====================================
                DEADLINE
            ====================================== */}

            <div className="mb-3">

              <label className="form-label">
                Deadline
              </label>

              <input
                type="date"
                className="form-control"
                name="deadline"
                value={
                  formData.deadline
                }
                onChange={
                  handleChange
                }
              />

            </div>

            {/* =====================================
                INTERNAL NOTES
            ====================================== */}

            <div className="mb-4">

              <label className="form-label">
                Internal Notes
              </label>

              <textarea
                rows="5"
                className="form-control"
                name="notes"
                value={
                  formData.notes
                }
                onChange={
                  handleChange
                }
                placeholder="Enter internal project notes"
              />

            </div>

            {/* =====================================
                BUTTONS
            ====================================== */}

            <div className="d-flex gap-2">

              <button
                type="button"
                className="btn btn-light"
                onClick={() =>
                  navigate(
                    "/projects"
                  )
                }
                disabled={
                  loading
                }
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={
                  loading ||
                  loadingDevelopers
                }
              >
                {loading
                  ? "Creating..."
                  : "Create Project"}
              </button>

            </div>

          </form>

        </div>
      </div>

    </div>
  );
}

export default CreateProject;